<template>
  <RouterLink
    :class="[
      'testv__post__item__wrapper',
      `testv__post__item__wrapper--${type}`
    ]"
    event=""
    :to="{ name: 'Post', params: { id: post.id }, query: { type: type } }"
    @click.native="onRoute">
    <div class="testv__post__item">
      <div class="testv__post__item__banner__wrapper">
        <img :src="banner"/>
      </div>
      <div class="testv__post__item__right">
        <div class="testv__post__item__title">{{ post.title }}</div>
        <TestvPostDate
          class="testv__post__item__date"
          :date="post.released_at"
          :category="post.title_prefix"
        />
      </div>
    </div>
  </RouterLink>
</template>

<script>
import TestvPostDate from '@/components/TestvPostDate/index.vue'
import { formatImageByImageMogr2, formatDate } from '@/utils/index.js'

export default {
  name: 'TestvPostItemMini',

  components: {
    TestvPostDate
  },

  props: {
    post: {
      type: Object,
      require: true
    }
  },

  computed: {
    type () {
      switch (this.post.post_type) {
        case 2:
          return 'video'
        case 4:
          return 'podcast'
        default:
          return 'normal'
      }
    },
    play () {
      return [2, 4].includes(this.post.post_type)
    },
    banner () {
      if (this.type === 'normal') {
        return this.formatImageByImageMogr2(this.post.banner, { mode: 'crop', w: 1420, h: 708 })
      }
      return this.formatImageByImageMogr2(this.post.banner, {})
    }
  },

  methods: {
    formatImageByImageMogr2,
    formatDate,
    onRoute () {
      // console.log('TestvPostItem: ', 'push')
      this.$store.commit('setAction', 'push')
      this.$router.push({ name: 'Post', query: { id: this.post.id, type: this.type } })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/styles/variable.styl"
.testv__post__item {
  display: flex;
  column-gap: 16px;
  padding:  24px 0;
  position: relative;
  @media (min-width: $screen-md) {
    column-gap: 24px;
    padding:  32px 0;
  }
  &::after {
    content: '';
    display: block;
    background-image: url("~@/assets/images/border.png")
    background-size: auto 100%;
    width: 100%;
    height: 2px;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .testv__post__item__banner__wrapper {
    flex-shrink: 0;
    width: 120px;
    height: calc(120px * (708 / 1420));
    background: var(--dark-bwb-2);
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
    }
    @media (min-width: $screen-md) {
      width: 160px;
      height: calc(160px * (708 / 1420));
    }
  }

  .testv__post__item__title {
    font-size: 17px;
    font-weight: 500px;
    margin-bottom: 8px;
    @media (min-width: $screen-md) {
      font-size: 24px;
    }
  }
  .testv__post__item__date {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-end;
    column-gap: 4px;
    --size-TestvPostDateText: 15px;
    --size-TestvPostDateIcon: 20px;
    --size-TestvPostDateText--md: 15px;
    --size-TestvPostDateIcon--md: 24px;
    --size-TestvPostDateText--max: 15px;
    --size-TestvPostDateIcon--max: 24px;
    color: var(--dark-bwb-5);
    >>> .testv__post__date {
      writing-mode: lr;
    }
  }
}
</style>
